// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"MedicationLists_dashboard__1RSTg","nothingSelected":"MedicationLists_nothingSelected__118JO","h4":"MedicationLists_h4__3woHV"};